import { yupResolver } from "@hookform/resolvers/yup";
import { EditarDataCampanhaStyle } from "./style";
import { useForm } from "react-hook-form";
import { Input } from "../../Input";
import { EditarCampanhaSchema } from "../../../schemas/campanha";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import Loading from "../../Loading";

export const AbrirRelatorio = ({ state, setGerarPdf, orcamentoSelecionado }) => {
  const {
    register,
    handleSubmit,
    reset
  } = useForm({
  });

  const [loading, setLoading] = useState(false);

  function buscarDadosMaterialQuantidades() {
    setLoading(true);
    api.get(`/material-briefin-quantidades/${orcamentoSelecionado.campanha_material_briefing_id
      }/${orcamentoSelecionado.quantidade}`)
      .then((response) => {
        setLoading(false);
        reset(response.data.data)
      })
      .catch(() => {
        setLoading(false);
        toast.error("Erro ao editar observação.");
      });
  }

  function editarObservacao(data) {
    api.patch(`/material-briefin-quantidades/${orcamentoSelecionado.campanha_material_briefing_id
      }/${orcamentoSelecionado.quantidade}`, { observacoes: data.observacoes })
      .then(() => {
        toast.success("Observação editada com sucesso.");
        buscarDadosMaterialQuantidades()
      })
      .catch(() => {
        toast.error("Erro ao editar observação.");
      });
  }

  useEffect(() => {
    buscarDadosMaterialQuantidades();
  }, []);

  return (
    <EditarDataCampanhaStyle>
      {loading ? <Loading className="loading" /> :
        <div>
          <form onSubmit={handleSubmit(editarObservacao)}>
            <span onClick={() => state(false)} className="close">
              X
            </span>
            <Input
              className="input"
              label="Observações:"
              type="text"
              register={register("observacoes")}
            />
            <button type="submit">Salvar observação</button>
            <button className="gerar" type="button" onClick={() => {
              state(false)
              setGerarPdf(true)
            }}>Gerar relatório</button>
          </form>
        </div>
      }
    </EditarDataCampanhaStyle>
  );
};
